import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, Ref, watch, computed, PropType } from 'vue'

interface OptionItem {
  id: string
  title: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AnswerInput',
  props: {
  modelValue: {
    type: String,
    default: '',
  },
  booleanValue: {
    // use this model for 'binaryChoice'
    type: Boolean,
    default: false,
  },
  multiChoiceValue: {
    type: Object as PropType<string[]>,
    default() {
      return []
    },
  },
  id: {
    type: String,
    default: '',
  },
  mode: {
    type: String,
    default: 'text', // 'binaryChoice', 'singleChoice', otherwise same as HTML Input types. e.g. 'text', 'tel', 'email', 'number'..
  },
  required: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array as PropType<OptionItem[]>,
    default: () => [],
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  // Use for scaling the input size for text input
  customSize: {
    type: String,
    default: '',
  },
  border: {
    type: Boolean,
    default: false,
  },
  underline: {
    type: Boolean,
    default: true,
  },
},
  emits: ['change', 'update:modelValue', 'update:booleanValue', 'update:multiChoiceValue', 'update:valid', 'enterkey'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const { mode, modelValue, booleanValue, multiChoiceValue, id } = toRefs(props)
const selectedValue: Ref<string | boolean> = mode.value === 'binaryChoice' ? ref(booleanValue.value) : ref(String(modelValue.value))
const selectedMultiChoice: Ref<string[]> = ref([])
const elementId = id.value ? id.value : 'ai-id-' + Math.floor(Math.random() * 10000000)
const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
const telRegex = new RegExp(/^\+?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{2,6}$/im)
const noWhitespacesRegex = new RegExp(/^(?!.*\s)/)

watch(
  () => props.modelValue,
  (newValue) => {
    selectedValue.value = String(newValue)
    emit('update:valid', isValid.value)
  },
)

watch(
  () => props.booleanValue,
  (newValue) => {
    selectedValue.value = !!newValue
    emit('update:valid', isValid.value)
  },
)

watch(
  () => props.multiChoiceValue,
  (newValue) => {
    selectedMultiChoice.value = newValue
    emit('update:valid', isValid.value)
  },
)

const enterKey = () => {
  emit('enterkey')
}

const isValid = computed(() => {
  let valid = false
  const v = selectedValue.value
  if (!v && props.required) return false
  switch (mode.value) {
    case 'tel':
      valid = telRegex.test(v as string)
      break
    case 'password':
      valid = noWhitespacesRegex.test(v as string)
      break
    case 'email':
      valid = emailRegex.test(v as string)
      break
    case 'binaryChoice':
      valid = selectedValue.value === true
      break
    default:
      valid = true
  }
  return valid
})

const valueInput = ($event: Event): void => {
  // const ie = $event.target as HTMLInputElement
  $event.stopImmediatePropagation()
  emit('update:modelValue', selectedValue.value) // If using v-model on this element, this is the updated value
  emit('update:booleanValue', selectedValue.value) // If using v-model on this element, this is the updated value
  emit('update:multiChoiceValue', multiChoiceValue.value)
  emit('update:valid', isValid.value) // Vue3 supports multiple v-model using naming - indicates the current entry is valid
  emit('change', selectedValue.value) // Also possible to listen for this change event if not using v-model
}

const __returned__ = { emit, props, mode, modelValue, booleanValue, multiChoiceValue, id, selectedValue, selectedMultiChoice, elementId, emailRegex, telRegex, noWhitespacesRegex, enterKey, isValid, valueInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})